// The dock's chat sheet (react/dock/chat). Opening it on a conversation goes
// through react/dock/chat/openDockChat, which also selects the room.
export const DOCK_CHAT_OPENED = 'DOCK_CHAT_OPENED';
export const DOCK_CHAT_CLOSED = 'DOCK_CHAT_CLOSED';
export const DOCK_CHAT_MESSAGE_SHOWN = 'DOCK_CHAT_MESSAGE_SHOWN';

/** conversation: { kind: 'room' | 'dm' | 'match', id }, or none to reopen the last one. */
export const dockChatOpened = ({ conversation = null, messageId = null } = {}) => ({
	type: DOCK_CHAT_OPENED,
	payload: { conversation, messageId },
});

export const closeDockChat = () => ({ type: DOCK_CHAT_CLOSED });

export const dockChatMessageShown = () => ({ type: DOCK_CHAT_MESSAGE_SHOWN });
